import React from "react";
import { createPortal } from "react-dom";
import { Modal } from "react-bootstrap";
import BootstrapModalManager from "react-bootstrap/BootstrapModalManager";
import styled from "styled-components";
import { colors } from "utils";
import { SecondaryButton, interText, marfaTitle } from "./styles";

// The pieces the warm-up modals share (Figma's Assign Groups and Edit Groups
// overlays): header row with the Marfa title and the 48 close circle, the
// body columns, the set name block, the directions and the buttons row.

// The page scrolls on <html> (the global style's overflow-x), so the body
// lock react-bootstrap applies never hides the page's scrollbar, and the fixed
// overlay is left that much narrower than the window. While a warm-up modal is
// shown, a <style> in the document head hides that scrollbar (the page still
// scrolls), so the overlay spans the whole window; with no scrollbar there is
// nothing to pad the body or the overlay for. A styled-components rule cannot
// do this: every rule it writes is scoped to the component's own class.
const StyledWarmUpModal = styled(Modal)`
  &.modal {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

class NoPageScrollbarModalManager extends BootstrapModalManager {
  getScrollbarWidth() {
    return 0;
  }
}

const warmUpModalManager = new NoPageScrollbarModalManager();

const HIDE_PAGE_SCROLLBAR = `
  html { scrollbar-width: none; }
  html::-webkit-scrollbar { display: none; }
`;

export const WarmUpModal = (props) => (
  <>
    {props.show &&
      createPortal(<style>{HIDE_PAGE_SCROLLBAR}</style>, document.head)}
    <StyledWarmUpModal manager={warmUpModalManager} {...props} />
  </>
);

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.h2`
  ${marfaTitle}
`;

export const CloseButton = styled.button`
  align-items: center;
  background: transparent;
  border: 2px solid ${colors.nightlyWoods950};
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  padding: 0;
  width: 48px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const InnerColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SetNameBlock = styled.div`
  ${interText(18, 26, 700)}
  background: ${colors.blue50};
  border-radius: 0;
  padding: 16px;
`;

export const Directions = styled.p`
  ${interText(18, 26)}
  margin: 0;
`;

export const ButtonsRow = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
`;

export const WideSecondaryButton = styled(SecondaryButton)`
  width: 180px;
`;
